import React from 'react';
import { Link } from 'react-router-dom';

export function ContactCTA() {
  return (
    <div className="mt-12 bg-accessible-red-600 rounded-lg p-8 text-white">
      <div className="text-center">
        <h2 className="heading-3-white mb-4">
          Potrzebujesz pomocy?
        </h2>
        <p className="body-medium-white mb-6">
          Skontaktuj się z nami, jeśli masz problemy z dostępnością strony lub potrzebujesz informacji w alternatywnej formie.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link
            to="/kontakt"
            className="bg-white text-accessible-red-600 px-8 py-4 rounded-lg hover:bg-accessible-gray-50 transition-colors flex items-center justify-center gap-2 shadow-lg"
          >
            <span>Kontakt</span>
          </Link>
        </div>
      </div>
    </div>
  );
}